import { render } from "./ContactComponent.vue?vue&type=template&id=284fcc21"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__